import { Field } from 'formik'
import { FC } from 'react'
import { observer } from 'mobx-react'
import styles from './index.module.scss'

type Props = {
  source: string
}

type Item = {
  item: string
}

const sources: Item[] = [
  {
    item: 'I use AQA products(browser, search, etc.)',
  },
  {
    item: 'A friend/colleague',
  },
  {
    item: 'A blog post/news article',
  },
  {
    item: 'An influencer/content creator I follow',
  },
  {
    item: 'A newsletter I subscribe to',
  },
  {
    item: 'From an online search for digital ads',
  },
  {
    item: 'A podcast I listen to',
  },
  {
    item: 'My website analytics',
  },
  {
    item: 'I saw an ad on LinkedIn',
  },
  {
    item: 'I saw an ad somewhere else (Twitter, TikTok, Facebook, Adweek, etc.)',
  },
  {
    item: 'Other',
  },
]

export const SourceAqaAdsSelectField: FC<Props> = observer(({ source }) => {
  return (
    <div className={styles.container}>
      <Field as='select' name='source'>
        <option value='Please select'>Please select</option>
        {sources.map((option) => {
          return (
            <option key={option.item} value={option.item}>
              {option.item}
            </option>
          )
        })}
      </Field>
      <input name='source' type='hidden' value={source} />
    </div>
  )
})
